// projects/humanresources-general/src/assets/i18n/*/hr-gen-employee-subtype.json
export class HrGenEmployeeSubtypeKey {
    private static readonly keyPrefix = 'hrGenEmployeeSubtype';
    public static title = `${HrGenEmployeeSubtypeKey.keyPrefix}.title`;
    public static pageHeader = `${HrGenEmployeeSubtypeKey.keyPrefix}.pageHeader`;
    public static employeeType = `${HrGenEmployeeSubtypeKey.keyPrefix}.employeeType`;
    public static employeeSubtypeText = `${HrGenEmployeeSubtypeKey.keyPrefix}.employeeSubtypeText`;
}
